import { StyleSheet } from "react-native";
import { Colors } from "../../../globalStyles/ColorConfig";
export const styles = StyleSheet.create({
  Container: {
    marginTop: 20,
  },
  ProfileWrap: {
    marginHorizontal: 16,
    borderBottomColor: "rgba(0,0,0,0.1)",
    borderBottomWidth: 1,
    marginTop: 20,
    paddingBottom: 20,
  },
  InterestCardImgWrap: { position: "relative" },
  InterestCard: {
    position: "relative",
  },
  InterestsProfileInfoWrap: {
    backgroundColor: Colors.darkGreen,
    marginTop: 10,
  },
  InterestsProfileInfo: {
    backgroundColor: "#fff",
    borderTopLeftRadius: 20,
    paddingTop: 15,
  },
  InterestsProfileInfoName: {
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  InterestCardImgIcon: {
    height: 25,
    width: 25,
    borderRadius: 20,
  },
  InterestsMessage: {
    position: "absolute",
    bottom: -10,
    width: "90%",
    backgroundColor: Colors.darkGreen,
    padding: 16,
    borderRadius: 10,
    borderBottomLeftRadius: 0,
  },
  InterestCardImg: {
    borderRadius: 10,
    width: "100%",
  },

  // feed styles
  HomeDisplayCardContainer: {},
  FeedContainer: {
    backgroundColor: "white",
  },
  Experiences: {
    paddingHorizontal: 16,
    marginTop: 32,
    width: "100%",
  },
  ExperienceCardImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  transparentPill: {
    borderRadius: 50,
    paddingVertical: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  reportButton: {
    borderColor: "rgba(0, 0, 0, 0.7)",
    borderWidth: 0.5,
    borderRadius: 50,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 16,
    width: "70%",
    marginBottom: 18,
    marginRight: 16,
    marginLeft: "auto",
  },
  ExperienceCard: {
    width: "100%",
    height: 290,
    borderRadius: 8,
    overflow: "hidden",
    marginBottom: 20,
  },
  FeedWrap: {
    flex: 1,
    height: "100%",
  },
  ProfileItem: {
    marginTop: 28,
  },
  DatingProfileDetails: {
    paddingHorizontal: 16,
    marginTop: 16,
  },
  HomeDisplayCardGradient: {
    position: "absolute",
    width: "100%",
    // left: 10,
    display: "flex",
    justifyContent: "center",
    transform: [{ scale: 1.09 }],
    bottom: 3,
    zIndex: 0,
  },
  PillItem: {
    borderColor: "rgba(0, 0, 0, 0.3)",
    borderWidth: 0.3,
    borderRadius: 50,
    display: "flex",
    gap: 4,
    flexDirection: "row",
    alignItems: "center",
    padding: 6,
  },

  Pills: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    gap: 8,
    marginTop: 8,
  },
  CrossIcon: {
    bottom: 75,
    left: 16,
    backgroundColor: "white",
    borderRadius: 50,
    padding: 16,
    width: 60,
    height: 60,
    zIndex: 1,
    // shadow
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    shadowRadius: 10,
    elevation: 1,
  },
  LikeIconCircle: {
    backgroundColor: "white",
    borderRadius: 50,
    padding: 16,
    zIndex: 1,
    // shadow
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.4,
    shadowRadius: 10,
    elevation: 1,
  },
  BadgeLabel: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  HomeDisplayCardImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  HomeDisplayCard: {
    width: "100%",
    position: "relative",
    overflow: "hidden",
    maxHeight: 450,
    marginBottom: 8,
  },
  HomeDisplayCardInfo: {
    position: "absolute",
    width: "100%",
    bottom: 0,
    padding: 16,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
});
